import { getUser, updateUser } from "services/commonServices";
import { GET_USER_FAILURE, GET_USER_REQUEST, GET_USER_RESET, GET_USER_SUCCESS, UPDATE_USER_ROLE_FAILURE, UPDATE_USER_ROLE_REQUEST, UPDATE_USER_ROLE_RESET, UPDATE_USER_ROLE_SUCCESS } from "./action-type";

export const getUserAction = (payload) => {

    return (dispatch) => {
        dispatch(getUserRequest());
        getUser(payload)
            .then((response) => {
                if (response.status === 200)
                    dispatch(getUserSuccess(response));
                else
                    dispatch(getUserFailure(response));
            })
            .catch((err) => {
                dispatch(getUserFailure(err));
            });

    };
}

export const updateUserRoleAction = (payload) => {

    return (dispatch) => {
        dispatch(updatetUserRoleRequest());
        updateUser(payload)
            .then((response) => {
                if (response.status === 200)
                    dispatch(updateUserRoleSuccess(response));
                else
                    dispatch(updateUserRoleFailure(response));
            })
            .catch((err) => {
                dispatch(updateUserRoleFailure(err));
            });

    };
}


export const getUserRequest = () => {
    return {
        type: GET_USER_REQUEST
    }
};

export const getUserSuccess = (response) => {
    return {
        type: GET_USER_SUCCESS,
        getUserResponse: response.data,
        isGetUserError: false,
        isGetUserSuccess: true
    }
};

export const getUserFailure = (error) => {
    return {
        type: GET_USER_FAILURE,
        getUserResponse: error,
        isGetUserError: true,
        isGetUserSuccess: false
    }
};

export const getUserReset = (error) => {
    return {
        type: GET_USER_RESET
    }
};

export const updatetUserRoleRequest = () => {
    return {
        type: UPDATE_USER_ROLE_REQUEST
    }
};

export const updateUserRoleSuccess = (response) => {
    return {
        type: UPDATE_USER_ROLE_SUCCESS,
        updateUserRoleResponse: response.data,
        isUpdateUserRoleError: false,
        isUpdateUserRoleSuccess: true
    }
};

export const updateUserRoleFailure = (error) => {
    return {
        type: UPDATE_USER_ROLE_FAILURE,
        updateUserRoleResponse: error,
        isUpdateUserRoleError: true,
        isUpdateUserRoleSuccess: false
    }
};

export const updatetUserRoleResetAction = () => {
    return {
        type: UPDATE_USER_ROLE_RESET
    }
};